import { ArrowSquareOut, GlobeSimple } from "@phosphor-icons/react";
import { useTheme } from "../../context/ThemeContext";

export function PlatformCard({ platform }) {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <a
      href={platform.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`group block p-3 rounded-lg border transition-all card-hover ${
        isDark
          ? "bg-[#0c0c16] border-white/10 hover:border-purple-500/30"
          : "bg-gray-50 border-gray-200 hover:border-purple-300"
      }`}
      data-testid={`platform-link-${platform.name?.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <GlobeSimple
            size={16}
            className={isDark ? "text-purple-400" : "text-purple-500"}
          />
          <span
            className={`text-sm font-medium ${
              isDark ? "text-white" : "text-gray-900"
            }`}
          >
            {platform.name}
          </span>
        </div>
        <ArrowSquareOut
          size={14}
          className={`opacity-0 group-hover:opacity-100 transition-opacity ${
            isDark ? "text-purple-400" : "text-purple-500"
          }`}
        />
      </div>
      <p
        className={`text-xs font-body mt-1 ${
          isDark ? "text-gray-500" : "text-gray-400"
        }`}
      >
        {platform.type?.replace("_", " ")}
      </p>
    </a>
  );
}
